export enum EVisitTypes {
  FrontDoor = 'FD', // Front Door
  SymptomChecker = 'SC' // Symptom Checker
}

export const EVisitTypeKey = 'eVisit.eVisitType';
